import axios from 'axios';

export async function getUserHierarchyTree(token) {
  const url = `Hierarchy/GetUserTree`;
  const request = {
    method: 'GET',
    url: url,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios(request);
  return res.data;
}

export async function getSavedSitesList({ areaId, areaName }) {
  const url = `Hierarchy/GetSavedSitesList`;
  const request = {
    method: 'GET',
    url: url,
    params: { areaId, areaName },
    headers: { background: 'true' },
  };

  const res = await axios(request);
  return res.data;
}




const SiteService = {
  API: {
    getUserHierarchyTree,
    getSavedSitesList,
  },
};

export default SiteService;